<div>
  <span class="title-text">{{ facetTitle() }}</span>
  <div class="row row-data">
    @for (facet of facetDetails(); track facet) {
      <div class="col title-text">
        <div
          class="layout-data"
          [ngStyle]="{ backgroundColor: facet.backgroundColor || 'white' }"
          [ngClass]="{ clickable: facet.clickable }"
          (click)="onFilter(facet)"
        >
          <div class="mb-2">
            <span class="status-text" [ngStyle]="{ color: facet.color }">{{ facet.title }}</span>
          </div>
          <div class="result-text">
            <span>{{ facet.totalResults }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>
